import React from 'react'

const CannabisIcon = props => (
  <svg viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.4"
      d="M9.66412 7.7449C9.66412 7.7449 8.64217 7.13878 7.38152 7.13878C7.00749 7.13878 6.65543 7.19265 6.34391 7.26775C6.80597 7.00969 7.33315 6.64793 7.80804 6.15742C8.99662 4.93002 9.40684 3.36376 9.40684 3.36376C9.40684 3.36376 7.88988 3.78714 6.7013 5.01454C6.33575 5.39213 6.04391 5.80171 5.81499 6.18795C5.99521 5.54883 6.14238 4.76996 6.14238 3.92857C6.14238 1.75888 5.16412 0 5.16412 0C5.16412 0 4.18586 1.75888 4.18586 3.92857C4.18586 4.76985 4.33304 5.54871 4.51315 6.18784C4.28412 5.80171 3.99238 5.39213 3.62684 5.01465C2.43836 3.78725 0.921623 3.36364 0.921623 3.36364C0.921623 3.36364 1.33162 4.93013 2.52021 6.15742C2.99521 6.64793 3.52249 7.00981 3.98467 7.26775C3.67304 7.19265 3.32086 7.13878 2.94673 7.13878C1.68608 7.13878 0.664124 7.7449 0.664124 7.7449C0.664124 7.7449 1.68608 8.35102 2.94673 8.35102C3.47771 8.35102 3.96499 8.24327 4.35271 8.11879C4.18293 8.23103 4.0063 8.36898 3.84206 8.53858C3.24782 9.15222 3.04271 9.93536 3.04271 9.93536C3.04271 9.93536 3.8013 9.72355 4.39543 9.10991C4.64217 8.85511 4.82097 8.57181 4.94662 8.32666V11H5.38141V8.32711C5.50717 8.57214 5.68597 8.85545 5.9326 9.11024C6.52684 9.72389 7.28521 9.93569 7.28521 9.93569C7.28521 9.93569 7.0801 9.15234 6.48586 8.53881C6.32151 8.36898 6.14488 8.23103 5.97499 8.11879C6.36271 8.24327 6.85032 8.35113 7.3813 8.35113C8.64217 8.35102 9.66412 7.7449 9.66412 7.7449ZM5.16412 7.85714H5.14923C5.15119 7.85153 5.15325 7.84569 5.1551 7.84042C5.16065 7.85086 5.16412 7.85714 5.16412 7.85714C5.16412 7.85714 5.16749 7.85086 5.17315 7.84064C5.17499 7.84592 5.17706 7.85164 5.17891 7.85714H5.16412Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-1.74659"
        y1="6.30451e-08"
        x2="10.394"
        y2="10.8725"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default CannabisIcon
